import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { RxFormBuilder, RxwebValidators } from '@rxweb/reactive-form-validators';
import { RiveModule } from 'ng-rive';
import { Subject, takeUntil } from 'rxjs';
import { UserActions } from 'src/app/store/user/user.actions';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.css'],
  standalone: true,
  imports: [RiveModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, CommonModule, FormsModule, ReactiveFormsModule, RouterModule]
})
export class EditPasswordComponent implements OnInit {
  passwordForm: FormGroup;
  showPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  showRive: boolean = false;
  destroy$: Subject<void> = new Subject<void>();
  passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\|"':;<,>.?\/\\])[A-Za-z\d!@#$%^&*()_\-+=\|"':;<,>.?\/\\]{8,}$/;

  isLengthValid: boolean = false;
  isLowercaseValid: boolean = false;
  isUppercaseValid: boolean = false;
  isNumberValid: boolean = false;
  isSpecialCharacterValid: boolean = false;

  constructor(
    private router: Router,
    private snackbarService: SnackbarService,
    private route: ActivatedRoute,
    private store: Store,
    private actions$: Actions) {

    this.passwordForm = new RxFormBuilder().group({
      old_password: ['', [RxwebValidators.notEmpty({ message: " Current password is required" })]],
      new_password: ['', [RxwebValidators.notEmpty({ message: "New Password is required" }), RxwebValidators.pattern({ expression: { password: this.passwordRegex }, message: "Invalid password" })]],
      confirm_password: ['', [RxwebValidators.compare({ fieldName: 'new_password', message: "Passwords must match" })]]
    });

    this.passwordForm.controls['new_password'].valueChanges
      .subscribe((newPassword: string) => {
        this.isLengthValid = newPassword.length >= 8;
        this.isLowercaseValid = /[a-z]/.test(newPassword);
        this.isUppercaseValid = /[A-Z]/.test(newPassword);
        this.isNumberValid = /\d/.test(newPassword);
        this.isSpecialCharacterValid = /[!@#$%^&*()_\-+=\|"':;<,>.?\/\\]/.test(newPassword);
      });
  }

  ngOnInit() {
  }

  checkFormValidation() {
    this.passwordForm.get('new_password')!.markAsTouched()
    this.passwordForm.get('confirm_password')!.markAsTouched()

    // validates password field
    if (!this.passwordForm.controls['new_password'].value) {
      this.passwordForm.controls['new_password'].setErrors({ required: true })
    }
    else if (this.passwordForm.controls['new_password'].value && !this.passwordRegex.test(this.passwordForm.controls['new_password'].value)) {
      this.passwordForm.controls['new_password'].setErrors({ invalidPassword: true })
    }

    // validates confirm password field
    if (!this.passwordForm.controls['new_password'].value && !this.passwordForm.controls['confirm_password'].value) {
      this.passwordForm.controls['confirm_password'].setErrors({ required: true })
    }
    else if (this.passwordForm.controls['new_password'].value && this.passwordForm.controls['new_password'].value != this.passwordForm.controls['confirm_password'].value) {
      this.passwordForm.controls['confirm_password'].setErrors({ match_error: true })
    }
  }

  onNewPasswordChange() {
    if (this.passwordForm.controls['new_password'].value == this.passwordForm.controls['confirm_password'].value) {
      this.passwordForm.controls['confirm_password'].setErrors({ match_error: false })
      this.passwordForm.controls['confirm_password'].errors
    }
  }

  isValid() {
    return this.passwordForm.valid
  }
  showError() {
    this.passwordForm.markAllAsTouched();
  }
  resetPassword() {
    this.checkFormValidation();

    if (this.passwordForm.valid) {
      this.showRive = true;
      const passwordsBody = {
        "old_password": this.passwordForm.controls['old_password'].value,
        "new_password": this.passwordForm.controls['new_password'].value
      }
      this.store.dispatch(UserActions.CHANGE_PASSWORD({ passwordBody: passwordsBody }));

      this.actions$.pipe(ofType(UserActions.CHANGE_PASSWORD_SUCCESS), takeUntil(this.destroy$)).subscribe(() => {
        this.store.dispatch(UserActions.GET_USER());
        this.snackbarService.openSnackBar('Password updated successfully', undefined);
        this.showRive = false;
        this.router.navigate(['../'], {
          relativeTo: this.route,
        })
      })

      this.actions$.pipe(ofType(UserActions.CHANGE_PASSWORD_FAILED), takeUntil(this.destroy$)).subscribe(() => {
        this.snackbarService.openSnackBar('Failed to Update Password', undefined);
        this.showRive = false;
      })
    }
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions to prevent memory leaks
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    this.router.navigate([''])
  }

}
